import { Combination as Combinations, CartesianProduct } from 'js-combinatorics';

/**
 * Returns all subsets of the given set with the specified size
 *
 * Examples:
 *   subsets([a, b, c], 1) => [[a], [b], [c]]
 *   subsets([a, b, c], 2) => [[a, b], [b, c], [a, c]]
 *   subsets([a, b, c], 3) => [[a, b, c]]
 */
const subsets = <T>(set: T[], size?: number): T[][] => [...new Combinations(set, size)];

/**
 * Returns all subsets of the given set (not including the empty set)
 *
 * Example:
 *   allSubsets([a, b, c]) => [
 *     [a], [b], [c],
 *     [a, b], [b, c], [a, c],
 *     [a, b, c]
 *   ]
 */
const allSubsets = <T>(set: T[]): T[][] => Array(set.length)
  .fill(0).flatMap((_, index) => subsets(set, index + 1));

/**
 * Returns the cartesian product of the given sets
 * Example:
 *   cartesianProduct([a, b, c], [1, 2, 3]) => [
 *     [a, 1], [a, 2], [a, 3],
 *     [b, 1], [b, 2], [b, 3],
 *     [c, 1], [c, 2], [c, 3]
 *   ]
 * @param args
 */
const cartesianProduct = <T>(...args: Iterable<T>[]): T[][] => [...new CartesianProduct(...args)];

export const math = {
  subsets,
  allSubsets,
  cartesianProduct
};